export default {
  actionToExecute: 'Acção a executar',
  addAction: 'Adicionar acção',
  addListToSequence: 'Adicionar lista à sequência',
  addPerson: 'Adicionar pessoa',
  addPersonOrStep: 'Adicionar pessoa ou passo',
  addScheduleName: 'Adicionar nome do horário',
  addScheduleObservations: 'Adicionar observações de calendário',
  addStep: 'Adicionar passo',
  addTask: 'Adicionar tarefa',
  addTrigger: 'Adicionar gatilho',
  addUserToSequence: 'Adicionar utilizador à sequência',
  automaticEmail: 'Correio electrónico automático',
  changeUserFromSequence: 'Alterar utilizador da sequência',
  companyName: 'Nome da empresa',
  completion: 'Conclusão',
  continueWithoutSaving: 'Continuar sem poupar',
  copyCustomizedField: 'Copiar campo personalizado',
  couldNotCopyFieldToClipboard: 'Não foi possível copiar campo para prancheta',
  createAValidTask: 'Criar uma tarefa válida',
  createRule: 'Criar regra',
  createSequence: 'Criar sequência',
  customFieldSuccessfullyCopiedToClipboard: 'Campo personalizado copiado com sucesso para prancheta',
  customizeDay: 'Personalizar o dia',
  customizeScheduleDays: 'Personalizar dias de calendário',
  dayDisabled: 'Dia com deficiência',
  days: 'Dias',
  deleteAction: 'Eliminar acção',
  deleteList: 'Eliminar lista',
  deleteSequence: 'Eliminar sequência',
  deleteTrigger: 'Apagar o gatilho',
  deleteUserFromSequence: 'Eliminar utilizador da sequência',
  deleteUserFromSequenceConfirmation: 'Quer realmente apagar este utilizador da sequência',
  doNothing: 'Não fazer nada',
  doYouReallyWanToDeleteThisSequence: 'Quer mesmo apagar esta sequência?',
  editList: 'Lista de edição',
  editPerson: 'Editar pessoa',
  editRule: 'Regra de edição',
  editSchedule: 'Editar calendário',
  emailHooksInformation: 'Informação sobre os ganchos do e-mail',
  emailStatistics: 'Estatísticas por correio electrónico',
  enterRuleDescription: 'Introduza a descrição da regra',
  editSequence: 'Sequência de edição',
  editStep: 'Etapa de edição',
  enterRuleName: 'Introduza o nome da regra',
  enterStepName: 'Introduza o nome do passo',
  enterStepOrder: 'Introduza a ordem dos passos',
  enterStepTips: 'Introduza as dicas dos passos',
  enterTaskName: 'Introduza o nome da tarefa',
  enterTriggerName: 'Introduzir o nome do gatilho',
  executeAnotherActionInAGivenTime: 'Executar outra acção num determinado período de tempo',
  exitWhen: 'Sair quando',
  goBackToTheSequence: 'Voltar à sequência',
  hours: 'Horas',
  ifNotSequenceStepPickedNote: 'Nota: Se não escolher um passo, o próximo passo da sequência será escolhido por defeito',
  insertEmailSubject: 'Inserir assunto de e-mail',
  isActive: 'Está activo',
  isDayActive: 'Está activo durante o dia',
  isGlobal: 'É global',
  isSequenceActive: 'Está activa a sequência',
  isStepActive: 'Está activo',
  lastEditionDate: 'Data da última edição',
  listNotFound: 'Lista não encontrada',
  listSuccessfullyAddedToSequence: 'Lista acrescentada com sucesso à sequência',
  listView: 'Vista de lista',
  loadingInformation: 'Carregamento de informação',
  loadingRule: 'Regra de carregamento',
  loadingSchedule: 'Horário de carregamento',
  loadingSequence: 'Sequência de carregamento',
  loadingSequenceStatistics: 'Estatísticas de sequência de carregamento',
  loadingStep: 'Etapa de carregamento',
  manualEmail: 'Manual e-mail',
  nestedActionToExecute: 'Acção aninhada para executar',
  newRule: 'Nova regra',
  newSchedule: 'Novo horário',
  newSequence: 'Nova sequência',
  noRulesCreated: 'Sem regras criadas',
  noSchedulesCreated: 'Sem horários criados',
  noSequencesCreated: 'Sem sequências criadas',
  order: 'Encomenda',
  owner: 'Proprietário',
  pauseSequence: 'Sequência de pausa',
  peopleInTheSequence: 'Pessoas na sequência',
  peoplePerStep: 'Pessoas por degrau',
  peopleThatLeftTheSequence: 'Pessoas que deixaram a sequência',
  personSuccessfullyAddedToSequence: 'Pessoa adicionada com sucesso à sequência',
  personSuccessfullyChangedFromSequence: 'Pessoa mudou de sequência com sucesso',
  personSuccessfullyCreated: 'Pessoa criada com sucesso',
  personSuccessfullyUpdated: 'Pessoa actualizada com sucesso',
  pickAnAction: 'Escolha uma acção',
  pickAnHour: 'Escolha uma hora',
  pickADate: 'Escolha uma data',
  pickARule: 'Escolha uma regra',
  pickASchedule: 'Escolha um horário',
  pickAScheduleForTheSequence: 'Escolher um horário para a sequência',
  pickAStep: 'Escolha um passo',
  pickFinishingTime: 'Escolha o tempo de acabamento',
  pickHour: 'Hora da colheita',
  pickMinutes: 'Escolha os minutos',
  pickTimeZone: 'Escolher fuso horário',
  pickStartingDateTimeAndTimeZone: 'Escolher a data de início, hora e fuso horário',
  pickStartingTime: 'Escolher a hora de início',
  pickTheSequenceToChangeTo: 'Escolha a sequência a alterar para',
  pickTheStepToChangeTo: 'Escolha o passo para mudar para',
  pickTriggerType: 'Escolher o tipo de gatilho',
  prepareEmail: 'Preparar e-mail',
  project: 'Projecto',
  relateRuleToSequence: 'Relacionar a regra com uma sequência',
  relateRuleToSequenceOrSetAsGlobal: 'Relacionar regra com uma sequência ou conjunto como global',
  removeUserFromSequence: 'Remover utilizador da sequência',
  ruleDetails: 'Detalhes das regras',
  ruleNotFound: 'Regra não encontrada',
  ruleSuccessfullyCreated: 'Regra criada com sucesso',
  ruleSuccessfullyUpdated: 'Regra actualizada com sucesso',
  rules: 'Regras',
  runSequence: 'Sequência de execução',
  saveTemplate: 'Salvar modelo',
  saveTemplateWarning: 'Não guardou ou actualizou este modelo, tem a certeza de continuar sem o guardar ou actualizar?',
  scheduleDays: 'Dias de calendário',
  scheduleName: 'Nome do horário',
  scheduleObservations: 'Programar observações',
  scheduleSuccessfullyCreated: 'Horário criado com sucesso',
  scheduleSuccessfullyUpdated: 'Horário actualizado com sucesso',
  schedules: 'Horários',
  seeList: 'Ver lista',
  seePerson: 'Ver pessoa',
  seeSequence: 'Ver sequência',
  selectARule: 'Seleccione uma regra',
  selectASequence: 'Seleccione uma sequência',
  sequence: 'Sequência',
  sequenceCompany: 'Sequência da empresa',
  sequenceDetails: 'Detalhes da sequência',
  sequenceInformationWillBeLostAfterDeletionOfTheSequence: 'Todas as pistas, passos e qualquer informação relacionada com a sequência deixarão de estar disponíveis',
  sequenceLeads: 'Sequência de pistas',
  sequenceName: 'Nome sequencial',
  sequenceOwner: 'Sequence owner',
  sequencePeople: 'Sequência de pessoas',
  sequenceRuleType: 'Tipo de regra',
  sequenceSchedule: 'Calendário das sequências',
  sequenceStatistics: 'Estatísticas das sequências',
  sequenceStatisticsNotFound: 'Estatísticas de sequências não encontradas',
  sequenceStatus: 'Estado sequencial',
  sequenceStatusSuccessfullyChanged: 'Estado de sequência alterado com sucesso',
  sequenceSteps: 'Passos sequenciais',
  sequenceSuccessfullyCreated: 'Sequência criada com sucesso',
  sequenceSuccessfullyDeleted: 'Sequência eliminada com sucesso',
  sequenceSuccessfullyUpdated: 'Sequência actualizada com sucesso',
  sequences: 'Sequências',
  sequencesRules: 'Regras de sequências',
  sequencesList: 'Lista de sequências',
  setRuleAsGlobal: 'Definir regra como global',
  sms: 'Sms',
  smsHooksInformation: 'Informação sobre os ganchos Sms',
  smsStatistics: 'Estatísticas Sms',
  social: 'Social',
  settings: 'Definições',
  statistics: 'Estatísticas',
  step: 'Etapa',
  stepSuccessfullyCreated: 'Passo criado com sucesso',
  stepSuccessfullyUpdated: 'Passo actualizado com sucesso',
  stepTips: 'Dicas de passos',
  stepType: 'Tipo de passo',
  task: 'Tarefa',
  taskHooksInformation: 'Informação sobre os ganchos da tarefa',
  taskStatistics: 'Estatísticas de tarefas',
  templateSuccessfullySaved: 'Modelo guardado com sucesso',
  templateSuccessfullyUpdated: 'Modelo actualizado com sucesso',
  theSequenceIsRunningNow: 'A sequência está a decorrer agora',
  timeToFinishTheTaskAfterRuleGetsExecuted: 'Tempo para terminar a tarefa após a regra ser executada',
  timeToWaitBeforeRunningThisStep: 'Tempo para esperar antes de executar esta etapa',
  timeToWaitBeforeNestedActionGetsExecuted: 'Tempo para esperar antes da acção aninhada ser executada',
  tipsForTheStep: 'Dicas para o {type}',
  triggerName: 'Nome do gatilho',
  triggerActions: 'Acções de desencadeamento',
  updateTemplateWarning: 'O modelo {templateName} vai ser actualizado, tem a certeza disso?',
  userNotFound: 'Utilizador não encontrado',
  userSuccessfullyDeletedFromSequence: 'Utilizador eliminado com sucesso da sequência',
  waitFor: 'Aguarde por',
  withoutTips: 'Sem dicas',
  writeEmail: 'Escrever e-mail',
  writeSms: 'Escrever SMS',
  youMustFillAllFieldsCorrectly: 'Deve preencher todos os campos correctamente',
  youMustPickADate: 'Deve escolher uma data',
  pickAnOutcome: 'Escolha um resultado',
  pickAnOutcomeForTheTask: 'Escolha um resultado para a tarefa',
  deliveredPlural: 'Entregue | Delivered',
  clickedPlural: 'Clicada | Clicada',
  deferral: 'Postergado | Postergado',
  hardBounced: 'Salto forte | Saltos fortes',
  softBounced: 'Salto suave | Saltos suaves',
  spamBlocked: 'Bloqueado por spam | Bloqueado por spam',
  unsubscribed: 'Não inscrito | Não inscrito',
  blackList: 'Lista negra',
  whiteList: 'Lista branca',
  unknown: 'Unknown | Unknown',
  pending: 'Pendente | Pendente',
  scheduled: 'Agendada | Agendada',
  queued: 'Enfileiradas | Enfileiradas'
}
